var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 4.5C3.996 4.50113 4.61756 4.50113 5.238 4.5L6.41419 10.7888C6.43275 10.8816 6.45525 10.9732 6.47944 11.0644C6.57169 10.6988 6.62963 10.3253 6.70669 9.95625L7.77769 4.5L9.57994 4.50056C8.919 7.44356 8.25806 10.3871 7.596 13.3301H5.35894C4.69688 10.3888 4.03594 7.4475 3.375 4.50563V4.5ZM10.3016 7.27425C10.6937 6.7815 11.3203 6.55819 11.9244 6.51881C12.5207 6.47719 13.1631 6.53119 13.6682 6.88669C14.1154 7.19944 14.3606 7.72819 14.4771 8.25412C14.6182 8.91337 14.6256 9.59062 14.625 10.2622H11.3231C11.3259 10.7589 11.295 11.2714 11.4609 11.7473C11.5414 11.9813 11.6916 12.2141 11.9301 12.2991C12.1843 12.3818 12.4903 12.3278 12.6759 12.123C12.9234 11.8429 12.9752 11.4502 13.0292 11.0908H14.5277C14.4939 11.6871 14.3837 12.3171 13.9933 12.7856C13.6018 13.2727 12.9707 13.4719 12.3733 13.4961C11.7242 13.5208 11.0194 13.4325 10.5019 12.9954C10.0209 12.5944 9.81113 11.9587 9.72788 11.3496C9.64463 10.6481 9.64013 9.93825 9.67894 9.23344C9.73125 8.54606 9.85556 7.81819 10.3011 7.27369L10.3016 7.27425ZM11.5807 7.97456C11.3254 8.34244 11.3186 8.81606 11.3231 9.24975H13.0286C13.0022 8.83744 13.005 8.40206 12.8194 8.02462C12.5888 7.55887 11.8597 7.55719 11.5819 7.97513H11.5807V7.97456Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeri);
export default __webpack_public_path__ + "static/media/veri.5e4830d836ac1ddf30a2768af30d2480.svg";
export { ForwardRef as ReactComponent };